/**
 * apiAuthFetch.ts
 * Anexa automaticamente o token da sessão Supabase (Authorization: Bearer) a toda chamada
 * fetch para /api/* do próprio domínio. O backend agora só aceita identidade via token
 * verificado; x-user-id e user_id no corpo não identificam mais o usuário.
 */
import { supabase } from './supabaseClient';

let cachedToken: string | null = null;

supabase.auth.onAuthStateChange((_event, session) => {
    cachedToken = session?.access_token ?? null;
});

const getToken = async (): Promise<string | null> => {
    if (cachedToken) return cachedToken;
    try {
        const { data } = await supabase.auth.getSession();
        cachedToken = data.session?.access_token ?? null;
    } catch {
        cachedToken = null;
    }
    return cachedToken;
};

if (typeof window !== 'undefined' && !(window as any).__librituiApiAuthFetch) {
    (window as any).__librituiApiAuthFetch = true;
    const originalFetch = window.fetch.bind(window);

    window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
        try {
            const rawUrl = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
            const url = new URL(rawUrl, window.location.origin);
            if (url.origin === window.location.origin && url.pathname.startsWith('/api/')) {
                const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
                if (!headers.get('Authorization')) {
                    const token = await getToken();
                    if (token) headers.set('Authorization', `Bearer ${token}`);
                }
                headers.delete('x-user-id');
                init = { ...init, headers };
            }
        } catch {
            // Em caso de URL inválida etc., segue com a requisição original
        }
        return originalFetch(input, init);
    };
}

export {};
